import { services as allServices, categoriesOrder } from '../constants/services';
export const groupByCategory = (serviceIds) => {
    const idSet = new Set(serviceIds);
    const visible = allServices.filter((service) => idSet.has(service.id));
    const byCategory = new Map();
    for (const service of visible) {
        const bucket = byCategory.get(service.category) ?? [];
        bucket.push(service);
        byCategory.set(service.category, bucket);
    }
    return categoriesOrder
        .filter((category) => byCategory.has(category))
        .map((category) => ({
        category,
        services: byCategory.get(category) ?? [],
    }));
};
